import { Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "react-datepicker/dist/react-datepicker.min.css";
import "./main.css";
import "./app.css";
import usgs_identifier from "../img/logo.png";
import NavContainer from "../containers/navContainer";
import DatepickerContainer from "../containers/datepickerContainer";
import DateRadiosContainer from "../containers/dateRadiosContainer";
import DataComponent from "./dataComponent";

const App = () => {
  const header = (
    <div className="header">
      <div id="usgsId">
        <img className="logo" src={usgs_identifier} alt="IdentfierImg" />
      </div>
    </div>
  );

  const footer = (
    <div id="usgsfooter" className="fixed-bottom">
      <p id="usgsfooterbar">
        <a
          href="http://www.usgs.gov/privacy.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          DOI Privacy Policy
        </a>
        <a
          href="http://www.usgs.gov/policies_notices.html"
          target="_blank"
          rel="noopener noreferrer"
        >
          Legal
        </a>
        ::
        <a
          href="https://www.usgs.gov/accessibility-and-us-geological-survey"
          target="_blank"
          rel="noopener noreferrer"
        >
          Accessibility
        </a>
        <a
          href="https://www.usgs.gov/sitemap"
          target="_blank"
          rel="noopener noreferrer"
        >
          Site Map
        </a>
        <a
          href="https://answers.usgs.gov/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Contact USGS
        </a>
        <a
          href="https://www.doi.gov/"
          target="_blank"
          rel="noopener noreferrer"
        >
          U.S. Department of the Interior
        </a>
        <a
          href="https://www.doioig.gov/"
          target="_blank"
          rel="noopener noreferrer"
        >
          DOI Inspector General
        </a>
        <a
          href="https://www.whitehouse.gov/"
          target="_blank"
          rel="noopener noreferrer"
        >
          White House
        </a>
        <a
          href="https://www.whitehouse.gov/omb/management/egov/"
          target="_blank"
          rel="noopener noreferrer"
        >
          E-gov
        </a>
        <a
          href="https://obamawhitehouse.archives.gov/open"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Government
        </a>
        <a
          href="https://www.doi.gov/pmb/eeo/reports-repository"
          target="_blank"
          rel="noopener noreferrer"
        >
          No Fear Act
        </a>
        <a
          href="https://www.usgs.gov/about/organization/science-support/foia"
          target="_blank"
          rel="noopener noreferrer"
        >
          FOIA
        </a>
      </p>
    </div>
  );

  return (
    <div>
      {header}
      <div className="app-body">
        <Row className="page-title align-items-center">
          <Col id="sub-title" xs={5} lg={3}>
            TNM Metrics
          </Col>
          <Col xs={7}>Data collection began January 25, 2020</Col>
        </Row>
        <Row className="row-hr">
          <hr className="custom" />
        </Row>
        <NavContainer />
        <Row className="row-hr" style={{ clear: "both" }}>
          <hr className="custom" />
        </Row>
        <div className="date-area">
          <DateRadiosContainer />
          <DatepickerContainer />
        </div>
        <DataComponent />
      </div>
      {footer}
    </div>
  );
};

export default App;
